// Mock data for Mallorie Consulting Group website

export const companyInfo = {
  name: "Mallorie Consulting Group",
  tagline: "Eccellenza nella Consulenza ISO e HSE",
  description: "Partner di fiducia per la certificazione ISO e la conformità HSE in tutta Italia",
  email: "info@mallorie-consulting.it",
  phone: "+39 0187 150 1655",
  phoneOffice: "+39 0187 150 1655",
  phoneSales: "+39 345 784 5440",
  address: "Via Roma 123, 19121 La Spezia, Italy",
  regions: ["La Spezia", "Firenze", "Milano", "Verona", "Bologna", "Roma", "London"]
};

export const services = [
  {
    id: "iso-9001",
    title: "ISO 9001",
    subtitle: "Sistema di Gestione Qualità",
    subtitleEn: "Quality Management System",
    description: "Consulenza completa per l'implementazione e certificazione ISO 9001. Vi guidiamo attraverso ogni fase del processo di certificazione con metodologie comprovate.",
    descriptionEn: "Complete consulting for ISO 9001 implementation and certification. We guide you through every phase of the certification process with proven methodologies.",
    benefits: [
      "Miglioramento dei processi aziendali",
      "Maggiore soddisfazione del cliente",
      "Riduzione degli sprechi e dei costi",
      "Vantaggio competitivo sul mercato"
    ],
    benefitsEn: [
      "Improved business processes",
      "Increased customer satisfaction",
      "Reduced waste and costs",
      "Competitive market advantage"
    ],
    icon: "award"
  },
  {
    id: "iso-45001",
    title: "ISO 45001",
    subtitle: "Salute e Sicurezza sul Lavoro",
    subtitleEn: "Occupational Health & Safety",
    description: "Implementazione di sistemi di gestione per la salute e sicurezza sul lavoro conformi agli standard internazionali ISO 45001.",
    descriptionEn: "Implementation of occupational health and safety management systems compliant with ISO 45001 international standards.",
    benefits: [
      "Riduzione degli infortuni sul lavoro",
      "Conformità normativa garantita",
      "Miglioramento del clima aziendale",
      "Riduzione dei costi assicurativi"
    ],
    benefitsEn: [
      "Reduced workplace accidents",
      "Guaranteed regulatory compliance",
      "Improved workplace environment",
      "Reduced insurance costs"
    ],
    icon: "shield-check"
  },
  {
    id: "iso-14001",
    title: "ISO 14001",
    subtitle: "Sistema di Gestione Ambientale",
    subtitleEn: "Environmental Management System",
    description: "Consulenza per la gestione ambientale e la certificazione ISO 14001, per un'azienda sostenibile e rispettosa dell'ambiente.",
    descriptionEn: "Consulting for environmental management and ISO 14001 certification, for a sustainable and environmentally responsible company.",
    benefits: [
      "Riduzione dell'impatto ambientale",
      "Conformità legislativa ambientale",
      "Risparmio energetico e risorse",
      "Immagine aziendale migliorata"
    ],
    benefitsEn: [
      "Reduced environmental impact",
      "Environmental legislative compliance",
      "Energy and resource savings",
      "Enhanced corporate image"
    ],
    icon: "leaf"
  },
  {
    id: "iso-27001",
    title: "ISO 27001",
    subtitle: "Sistema di Gestione Sicurezza Informazioni",
    subtitleEn: "Information Security Management System",
    description: "Preparazione e conformità per la certificazione ISO 27001. Proteggiamo i vostri dati aziendali con standard di sicurezza informatica riconosciuti a livello internazionale.",
    descriptionEn: "Preparation and compliance for ISO 27001 certification. We protect your business data with internationally recognized information security standards.",
    benefits: [
      "Protezione dei dati aziendali sensibili",
      "Conformità GDPR e normative privacy",
      "Riduzione dei rischi cyber security",
      "Fiducia di clienti e partner"
    ],
    benefitsEn: [
      "Protection of sensitive business data",
      "GDPR and privacy regulations compliance",
      "Reduced cybersecurity risks",
      "Trust of clients and partners"
    ],
    icon: "shield"
  },
  {
    id: "hse-compliance",
    title: "Conformità HSE",
    titleEn: "HSE Compliance",
    subtitle: "Health, Safety & Environment",
    subtitleEn: "Health, Safety & Environment",
    description: "Supporto completo per la conformità normativa in materia di salute, sicurezza e ambiente sul posto di lavoro.",
    descriptionEn: "Complete support for regulatory compliance in health, safety and environment in the workplace.",
    benefits: [
      "Audit e valutazioni complete",
      "Formazione del personale",
      "Documentazione conforme",
      "Monitoraggio continuo"
    ],
    benefitsEn: [
      "Complete audits and assessments",
      "Staff training",
      "Compliant documentation",
      "Continuous monitoring"
    ],
    icon: "clipboard-check"
  }
];

export const whyChooseUs = [
  {
    title: "Esperienza Comprovata",
    titleEn: "Proven Experience",
    description: "Anni di esperienza nella consulenza per certificazioni ISO in diversi settori industriali",
    descriptionEn: "Years of experience in ISO certification consulting across various industrial sectors",
    icon: "briefcase"
  },
  {
    title: "Approccio Personalizzato",
    titleEn: "Personalized Approach",
    description: "Ogni azienda è unica. Sviluppiamo soluzioni su misura per le vostre specifiche esigenze",
    descriptionEn: "Every company is unique. We develop tailored solutions for your specific needs",
    icon: "users"
  },
  {
    title: "Supporto Continuo",
    titleEn: "Continuous Support",
    description: "Non vi lasciamo soli dopo la certificazione. Assistenza continua per il mantenimento",
    descriptionEn: "We don't leave you alone after certification. Continuous assistance for maintenance",
    icon: "headphones"
  },
  {
    title: "Copertura Territoriale",
    titleEn: "Territorial Coverage",
    description: "Servizi a La Spezia, Firenze, Milano, Verona, Bologna e Roma con presenza locale",
    descriptionEn: "Services in La Spezia, Florence, Milan, Verona, Bologna and Rome with local presence",
    icon: "map-pin"
  }
];

export const blogPosts = [
  {
    id: "1",
    title: "ISO 9001:2015 - Cosa è cambiato e perché è importante",
    titleEn: "ISO 9001:2015 - What Has Changed and Why It Matters",
    excerpt: "Scopri le principali modifiche della norma ISO 9001:2015 e come possono migliorare la tua organizzazione.",
    excerptEn: "Discover the main changes in the ISO 9001:2015 standard and how they can improve your organization.",
    category: "ISO 9001",
    date: "2024-01-15",
    readTime: "5 min",
    author: "Mallorie Consulting",
    slug: "iso-9001-2015-cambiamenti"
  },
  {
    id: "2",
    title: "5 Vantaggi Concreti della Certificazione ISO 45001",
    titleEn: "5 Concrete Benefits of ISO 45001 Certification",
    excerpt: "Come la certificazione ISO 45001 può ridurre gli infortuni e migliorare la cultura della sicurezza in azienda.",
    excerptEn: "How ISO 45001 certification can reduce accidents and improve safety culture in your company.",
    category: "ISO 45001",
    date: "2024-01-10",
    readTime: "4 min",
    author: "Mallorie Consulting",
    slug: "vantaggi-iso-45001"
  },
  {
    id: "3",
    title: "Sostenibilità Aziendale: Il Ruolo della ISO 14001",
    titleEn: "Corporate Sustainability: The Role of ISO 14001",
    excerpt: "Come implementare un sistema di gestione ambientale efficace e ottenere la certificazione ISO 14001.",
    excerptEn: "How to implement an effective environmental management system and achieve ISO 14001 certification.",
    category: "ISO 14001",
    date: "2024-01-05",
    readTime: "6 min",
    author: "Mallorie Consulting",
    slug: "sostenibilita-iso-14001"
  },
  {
    id: "4",
    title: "Guida alla Conformità HSE nel 2024",
    titleEn: "Guide to HSE Compliance in 2024",
    excerpt: "Tutti gli aggiornamenti normativi in materia di salute, sicurezza e ambiente per il 2024.",
    excerptEn: "All regulatory updates on health, safety and environment for 2024.",
    category: "HSE",
    date: "2024-01-02",
    readTime: "7 min",
    author: "Mallorie Consulting",
    slug: "guida-conformita-hse-2024"
  }
];

export const faqs = [
  {
    question: "Quanto tempo richiede il processo di certificazione ISO?",
    questionEn: "How long does the ISO certification process take?",
    answer: "Il tempo necessario varia in base alle dimensioni dell'azienda e al sistema già in atto. In media, il processo di certificazione ISO 9001 richiede 6-12 mesi, mentre ISO 45001 e ISO 14001 possono richiedere 8-14 mesi.",
    answerEn: "The time required varies based on company size and the existing system in place. On average, ISO 9001 certification takes 6-12 months, while ISO 45001 and ISO 14001 may require 8-14 months."
  },
  {
    question: "Quali sono i costi della certificazione?",
    questionEn: "What are the certification costs?",
    answer: "I costi dipendono da diversi fattori: dimensioni dell'azienda, complessità dei processi, stato attuale del sistema di gestione. Offriamo un preventivo personalizzato gratuito dopo un'analisi preliminare.",
    answerEn: "Costs depend on several factors: company size, process complexity, current state of the management system. We offer a free personalized quote after a preliminary analysis."
  },
  {
    question: "La certificazione ISO è obbligatoria?",
    questionEn: "Is ISO certification mandatory?",
    answer: "La certificazione ISO non è legalmente obbligatoria, ma può essere richiesta da clienti, partner commerciali o bandi pubblici. Inoltre, migliora significativamente l'efficienza operativa e la reputazione aziendale.",
    answerEn: "ISO certification is not legally mandatory, but may be required by customers, business partners, or public tenders. Additionally, it significantly improves operational efficiency and corporate reputation."
  },
  {
    question: "Supportate aziende in tutta Italia?",
    questionEn: "Do you support companies throughout Italy?",
    answer: "Sì, operiamo principalmente a La Spezia, Firenze, Milano, Verona, Bologna e Roma, ma possiamo supportare aziende in tutta Italia grazie alla nostra rete di collaboratori qualificati.",
    answerEn: "Yes, we primarily operate in La Spezia, Florence, Milan, Verona, Bologna and Rome, but we can support companies throughout Italy thanks to our network of qualified partners."
  }
];

export const testimonials = [
  {
    id: "1",
    name: "Marco Rossi",
    company: "Industrie Meccaniche SpA",
    location: "Genova",
    text: "Grazie a Mallorie Consulting abbiamo ottenuto la certificazione ISO 9001 in tempi record. Professionalità e competenza eccezionali.",
    textEn: "Thanks to Mallorie Consulting we obtained ISO 9001 certification in record time. Exceptional professionalism and expertise.",
    rating: 5
  },
  {
    id: "2",
    name: "Laura Bianchi",
    company: "Logistica Toscana Srl",
    location: "Firenze",
    text: "Supporto impeccabile per la ISO 45001. Hanno trasformato completamente la nostra cultura della sicurezza.",
    textEn: "Impeccable support for ISO 45001. They completely transformed our safety culture.",
    rating: 5
  },
  {
    id: "3",
    name: "James Mitchell",
    company: "TechSecure Solutions Ltd",
    location: "London, UK",
    text: "Eccellente consulenza per la certificazione ISO 27001. Competenza internazionale e approccio pragmatico che ha reso il processo molto più semplice per la nostra azienda tecnologica.",
    textEn: "Outstanding consultancy for ISO 27001 certification. International expertise and pragmatic approach that made the process much simpler for our technology company.",
    rating: 5
  },
  {
    id: "4",
    name: "Giuseppe Ferrari",
    company: "EcoTech Solutions",
    location: "Milano",
    text: "Consulenza eccellente per ISO 14001. Ora siamo leader nella sostenibilità del nostro settore.",
    textEn: "Excellent consulting for ISO 14001. Now we are leaders in sustainability in our sector.",
    rating: 5
  }
];

// Form submission handler (mock)
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      localStorage.setItem('lastContact_' + Date.now(), JSON.stringify(formData));
      resolve({ success: true, message: "Grazie per averci contattato. Ti risponderemo entro 24 ore." });
    }, 1000);
  });
};

export const submitQuoteRequest = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Quote request submitted:", formData);
      localStorage.setItem('lastQuote_' + Date.now(), JSON.stringify(formData));
      resolve({ success: true, message: "Richiesta preventivo ricevuta. Ti contatteremo entro 48 ore con un'offerta personalizzata." });
    }, 1000);
  });
};
